export const environment = {
  production: true,
  env: 'demo',
  apiUrl: 'https://api-demo.caremessenger.co.uk/v2',
  signalingUrl: 'https://signal.bxthree.com',
  pusherKey: '3172982b265ddb84b0ad',
  ravenDsn: 'https://38905d172d76492b8b6c3c8cd9d97d2b@sentry.bxthree.com/41',
};
